export function loadSurgicalList() {
  // let list = document.querySelector('.surgical__container .surgical__list');
  // list.innerHTML = `
  //   <div class="surgical" data-surgical-id="1">
  //     <span class="surgical__name">Surgical</span>
  //     <span class="surgical__checkbox" data-surgical-id="1">
  //         <i class="surgical__icon-check ri-check-line"></i>
  //     </span>
  //   </div>
  //   <div class="surgical" data-surgical-id="0">
  //     <span class="surgical__name">Non surgical</span>
  //     <span class="surgical__checkbox" data-surgical-id="0">
  //         <i class="surgical__icon-check ri-check-line"></i>
  //     </span>
  //   </div>
  // `;
}
